import c from "./_memoizeCapped.js";
var n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, s = /\\(\\)?/g, u = c(function(e) {
  var r = [];
  return e.charCodeAt(0) === 46 && r.push(""), e.replace(n, function(a, t, o, p) {
    r.push(o ? p.replace(s, "$1") : t || a);
  }), r;
});
const i = u;
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_stringToPath.js
// module id = 1511
// module chunks = 41